import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './loginform.css';

function LoginForm() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [site, setSite] = useState('');
  const [sites, setSites] = useState([]); // State to store the list of sites
  const [errorMessage, setErrorMessage] = useState(''); // State for displaying errors
  const navigate = useNavigate();

  // Fetch the site data from the backend on component mount
  useEffect(() => {
    axios.get('http://localhost:5000/sites')
      .then((res) => {
        // Set the site data from the API response
        setSites(res.data);
      })
      .catch((err) => {
        console.error('Error fetching site data:', err);
        setErrorMessage('Failed to load site data');
      });
  }, []);

  function handleSubmit(event) {
    event.preventDefault();

    axios.post('http://localhost:5000/login', { username, password, site })
  .then(res => {
    console.log("Login successful:", res.data);
    navigate('/dashboard');
    // Handle successful login (e.g., store session/token, redirect to dashboard)
  })
  .catch(err => {
    console.error('Login failed:', err.response ? err.response.data : err.message);
    alert('Login failed: ' + (err.response ? err.response.data.message : err.message));
  });
  }

  return (
    <div className="body">
      <div className="wrapper">
        <form onSubmit={handleSubmit}>
          <h2>Login</h2>

          <div className="input-field">
            <input
              type="text"
              name="username"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
            <label htmlFor="username">Employee ID</label>
          </div>

          <div className="input-field">
            <input
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="password">Password</label>
          </div>

          <div className="input-field">
            <select
              name="site_cd"
              id="sitecd"
              value={site}
              onChange={(e) => setSite(e.target.value)}
              required
            >
              <option value="">Select Site</option>
              {/* Dynamically populate the select options */}
              {sites.map((siteData) => (
                <option key={siteData.site_cd} value={siteData.site_cd}>
                  {siteData.site_cd} - {siteData.site_name}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" className="button">
            Log In
          </button>

          {/* Display the error message if any */}
          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
